import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { GridState, ReportsService } from './reports.service';

@Injectable({ providedIn: 'root' })
export class GridStateService {
  constructor(private cService: CommonService) {}

  deepCopyGridState(gridStates: Array<any>): GridState {
    const gridState: GridState = {
      sortModel: [],
      filterModel: [],
      displayedColumns: [],
      overrideAPIColumnsVisibility: [],
      hiddenColumns: [],
      columnGroups: [],
      selectedServerFilter: {},
    };

    gridStates.forEach((gState) => {
      gridState.sortModel = [...gridState.sortModel, ...(gState?.sortModel ?? [])];
      gridState.filterModel = { ...gridState.filterModel, ...(gState?.filterModel ?? {}) };
      gridState.displayedColumns = [...gridState.displayedColumns, ...(gState?.displayedColumns ?? [])];
      gridState.overrideAPIColumnsVisibility = [
        ...gridState.overrideAPIColumnsVisibility,
        ...(gState?.overrideAPIColumnsVisibility ?? []),
      ];
      gridState.hiddenColumns = [...gridState.hiddenColumns, ...(gState?.hiddenColumns ?? [])];
      gridState.columnGroups = [...gridState.columnGroups, ...(gState?.columnGroups ?? [])];
      gridState.selectedServerFilter = {
        ...gridState.selectedServerFilter,
        ...(gState?.selectedServerFilter ?? {}),
      };
    });

    return gridState;
  }

  setCurrentActiveQueryFilters(filters: string[]): void {
    localStorage.setItem(this.cService.localStorageKeys.activeQueryFilters, JSON.stringify(filters));
  }

  getCurrentActiveQueryFilters(): string[] {
    return JSON.parse(localStorage.getItem(this.cService.localStorageKeys.activeQueryFilters)) ?? [];
  }

  unapplyStaleQueryFilters(cachedFilterModel: any): any {
    const staleQueryFilters = this.getCurrentActiveQueryFilters();

    staleQueryFilters.forEach((staleFilter) => {
      const { [staleFilter]: removedStaleFilter, ...updatedCachedFilterModel } = cachedFilterModel;
      cachedFilterModel = updatedCachedFilterModel;
    });

    return cachedFilterModel;
  }
}
